import { render } from "./ItemTable3.vue?vue&type=template&id=101e6b3c"
import script from "./ItemTable3.vue?vue&type=script&lang=js"
export * from "./ItemTable3.vue?vue&type=script&lang=js"

import "./ItemTable3.vue?vue&type=style&index=0&id=101e6b3c&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__